import React from "react";
import reactDom from "react-dom";
import styled from "./Modal.module.css";

const ModalOverlay = function (props) {
  return <div className={styled.backdrop} onClick={props.onClose} />;
};

const ModalContent = function (props) {
  return (
    <div className={styled.modal}>
      <div className={styled.content}>
        <h1 className={styled.title}>{props.title}</h1>
        <p>{props.info}</p>
      </div>
      <button onClick={props.onClose} className={styled.button}>
        Close
      </button>
    </div>
  );
};

const Modal = function (props) {
  const portalLocation = document.getElementById("portal");
  return (
    <React.Fragment>
      {reactDom.createPortal(
        <ModalOverlay onClose={props.onClose} />,
        portalLocation
      )}
      {reactDom.createPortal(
        <ModalContent
          title={props.title}
          info={props.info}
          onClose={props.onClose}
        />,
        portalLocation
      )}
    </React.Fragment>
  );
};

export default Modal;
